/* @flow */

import React, { Component } from 'react';


export default class HeaderRow extends Component {
  render() {
    var colspan = (this.props.tab === 3) ? 8 : 7;
    return (
      <tr className='header'><td colSpan={colspan}>Scientific Program ({this.props.title})</td></tr>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/headerRow.js
 **/